import React from "react";
import "./BrandCustomer.scss";
import b1 from "../../../src/assets/images/b1.png";
import b2 from "../../../src/assets/images/b2.png";
import b3 from "../../../src/assets/images/b3.png";
import b4 from "../../../src/assets/images/b4.png";
import b5 from "../../../src/assets/images/b5.png";
import b6 from "../../../src/assets/images/b6.png";
import b7 from "../../../src/assets/images/b7.png";
import b8 from "../../../src/assets/images/b8.png";

const BrandCustomer = () => {
  const imagArray = [
    {
      url: b1,
    },
    {
      url: b2,
    },
    {
      url: b3,
    },
    {
      url: b4,
    },
    {
      url: b5,
    },
    {
      url: b6,
    },
    {
      url: b7,
    },
    {
      url: b8,
    },
  ];

  return (
    <section className="brand_container">
      <div className="brand_text">
        <h2>
          "Trained on{" "}
          <span
            style={{
              color: "#F87171",
              fontWeight: "800",
            }}
          >
            10M+
          </span>{" "}
          Fashion eCommerce Images”
        </h2>
      </div>
      <div className="brand_subtext">
        <span>Trusted by 500+ clients worldwide</span>
      </div>
      <div className="brand_listing">
        {imagArray.slice(0, 4).map((item, index) => {
          return (
            <div key={index} className="center-x ">
              <img
                src={item.url}
                alt=""
                className="brand_img"
                style={{
                  width: "110px",
                  height: "100px",
                  objectFit: "contain",
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="brand_listing">
        {imagArray.slice(4, 8).map((item, index) => {
          return (
            <div key={index} className="center-x">
              <img
                src={item.url}
                alt=""
                style={{
                  width: "110px",
                  height: "100px",
                  objectFit: "contain",
                }}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default BrandCustomer;
